import reactDom from 'react-dom'
const LoginFooter = () => {
    return reactDom.createPortal(
        <div className="login-footer">
            <div className="social__icons__login">
                <a href="https://www.facebook.com/GamerZonei5" className="social-link__login" target="_blank" rel="noopener noreferrer"><i className="facebook icon"></i></a>
                <a href="#afzal" className="social-link__login" target="_blank" rel="noopener noreferrer"><i className="twitter icon"></i></a>
                <a href="https://www.linkedin.com/in/afzal-saiyed-b25004200/" className="social-link__login" target="_blank" rel="noopener noreferrer"><i className="linkedin icon"></i></a>
                <a href="https://www.instagram.com/afzal__saiyed/" className="social-link__login" target="_blank" rel="noopener noreferrer"><i className="instagram icon"></i></a>
                <a href="https://www.youtube.com/channel/UCqHpah7p2NjkLxywQfG0d-Q" className="social-link__login" target="_blank" rel="noopener noreferrer"><i className="youtube icon"></i></a>
                <a href="https://github.com/gmrzone" className="social-link__login" target="_blank" rel="noopener noreferrer"><i className="github icon"></i></a>
            </div>
            <div className="footer-end">
                &#169; 2019-2021 CoreCare Technologies Pvt Ltd
            </div>
        </div>,
        document.getElementById('footer')
    )
}

export default LoginFooter